import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import axios from "axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
// import { LoDashStatic } from "lodash";
const API_URL = process.env.REACT_APP_BASE_URL;
const headers = {
  "Content-Type": "application/json",
};

export interface Organisation {
  id?: number;
  packageName: string;
  districtCode: string;
  districtName: string;
  state: string;
  status: boolean;
  createBy?: string;
  updatedBy?: string;
  createDate?: string;
  updateDate?: string;
}
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchModules = createAsyncThunk(
  "modules/fetchModules",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: ColumnFiltersState;
  }) => {
    try {
      const params: Record<string, any> = {
        page,
        page_size: pageSize,
      };

      if (search) params.search = search;

      if (sort) {
        params.ordering = order === "desc" ? `-${sort}` : sort;
      }

      if (filters && Array.isArray(filters)) {
        filters.forEach((filter) => {
          const { id, value } = filter;
          if (!id || value === undefined || value === "") return;

          if (
            (id === "updated_at" || id === "created_at") &&
            typeof value === "object"
          ) {
            const { from_date, to_date } = value as {
              from_date?: string;
              to_date?: string;
            };
            if (from_date) params[`${id}_from`] = from_date;
            if (to_date) params[`${id}_to`] = to_date;
          } else {
            params[id] = value;
          }
        });
      }

      const response: any = await Axios.get(
        `${API_ENDPOINT?.USER_MANAGEMENT?.MODULE?.LIST}`,
        { params }
      );

      const responseData = response.data;
      return {
        data: responseData.data || [],
        rowCount: responseData.total_records || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchModules error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch Modules");
    }
  }
);

export const fetchModuleByID = createAsyncThunk(
  "modules/fetchModulesByID",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_ENDPOINT?.USER_MANAGEMENT?.MODULE?.DETAIL(id)}`
      );
      return response?.data || [];
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Modules by ID"
      );
    }
  }
);

export const updateModules = createAsyncThunk(
  "organisation/updateModules",
  async ({ id, data }: { id: string; data: any }, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `${API_ENDPOINT?.USER_MANAGEMENT?.MODULE?.UPDATE(id)}`,
        data
      );
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Failed to Update Module");
    }
  }
);

export const updateModulesStatus = createAsyncThunk(
  "organisation/updateModuels",
  async (moduleData: any, { rejectWithValue }) => {
    try {
      const payload = {
        is_active: moduleData.is_active, // only field being updated
      };
      const response = await Axios.patch(
        `${API_ENDPOINT?.USER_MANAGEMENT?.MODULE?.STATUS_UPDATE(
          moduleData.modulemaster_id
        )}`,
        payload
      );

      return response.data;
    } catch (error: any) {
      console.error("Status update failed", error);
      return rejectWithValue(error?.response?.data || "Status update failed");
    }
  }
);

export const addModuels = createAsyncThunk(
  "modulemaster/bulk-create",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        `${API_ENDPOINT?.USER_MANAGEMENT?.MODULE?.CREATE}`,
        data
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add Modules");
    }
  }
);

export const deleteModules = createAsyncThunk(
  "modules/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      await axios.delete(
        `${API_ENDPOINT?.USER_MANAGEMENT?.MODULE?.DELETE(id)}`
      );
      return id;
    } catch (err: any) {
      console.error("Delete error:", err);
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchAllModulesDropdowns = createAsyncThunk(
  "modules/fetchAllModulesDropdowns",
  async () => {
    try {
      const [
        orgRes,
        // industryRes, cityRes, stateRes,pincodeRes
      ] = await Promise.all([
        Axios.get(`/user-management/module-master/dropdown/app_name`, {
          headers,
        }),
      ]);

      return { appNameDropDown: orgRes?.data?.data?.app_name };

      // }
    } catch (err) {
      throw err;
    }
  }
);

export const fetchModulesDropdownsList = createAsyncThunk(
  "modules/fetchAllModulesDropdowns",
  async (query) => {
    try {
      const res = await Axios.get(
        `/user-management/module-master/modulelist/${query}`
      );

      return res.data;
    } catch (err) {
      throw err;
    }
  }
);

export const ModulesxportsCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();
  // params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(({ id, value }: { id: string; value: any }) => {
      if (id && value !== undefined && value !== null) {
        if (typeof value === "object" && value !== null) {
          const maybeDateFilter = value as {
            from_date?: string;
            to_date?: string;
          };

          if (
            (maybeDateFilter.from_date || maybeDateFilter.to_date) &&
            (id === "created_at" || id === "updated_at")
          ) {
            if (maybeDateFilter.from_date) {
              params.append(`${id}_from`, maybeDateFilter.from_date);
            }

            if (maybeDateFilter.to_date) {
              params.append(`${id}_to`, maybeDateFilter.to_date);
            }

            return;
          }

          // Other object filters
          Object.entries(value).forEach(([key, val]) => {
            if (val !== undefined && val !== null && val !== "") {
              params.append(key, String(val));
            }
          });
        } else {
          params.append(id, value);
        }
      }
    });
  }

  const response = await Axios.get(
    `${API_ENDPOINT?.USER_MANAGEMENT?.MODULE?.EXPORT}/?${params.toString()}`,
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") ||
      `Module_${new Date().toISOString().split("T")[0]}.csv`,
  };
};
